const translations = {
  PASS_MODAL_APPROVING_MANAGER: {
    description: 'Approving Manager',
    primaryValue: 'Approving Manager',
    stringKey: 'PASS_MODAL_APPROVING_MANAGER',
  },
  PASS_MODAL_AVAILABLE: {
    description: 'Available Passes',
    primaryValue: '{{remaining}} of {{total}} Available',
    stringKey: 'PASS_MODAL_AVAILABLE',
  },
  PASS_MODAL_CHECK_IN: {
    description: 'Register and Check In',
    primaryValue: 'Register and Check In',
    stringKey: 'PASS_MODAL_CHECK_IN',
  },
  PASS_MODAL_COMP_AMOUNT_HEADING: {
    description: 'Comp Amount Heading',
    primaryValue: 'Comp Amount',
    stringKey: 'PASS_MODAL_COMP_AMOUNT_HEADING',
  },
  PASS_MODAL_COMP_AMOUNT_HELP_TEXT: {
    description: 'Comp Amount Help Text',
    primaryValue:
      'Any amount over $1,000 must be approved by DTC Leadership; please contact the store for approval',
    stringKey: 'PASS_MODAL_COMP_AMOUNT_HELP_TEXT',
  },
  PASS_MODAL_COMP_NUMBER_HEADING: {
    description: 'Comp Number Heading',
    primaryValue: 'Comp Number',
    stringKey: 'PASS_MODAL_COMP_NUMBER_HEADING',
  },
  PASS_MODAL_COMP_TAB: {
    description: 'Comp Tab',
    primaryValue: 'Comp',
    stringKey: 'PASS_MODAL_COMP_TAB',
  },
  PASS_MODAL_DATE_HEADING: {
    description: 'Date Heading',
    primaryValue: 'Date',
    stringKey: 'PASS_MODAL_DATE_HEADING',
  },
  PASS_MODAL_DATE_RANGE: {
    description: 'Date Range',
    primaryValue: 'Most pass types are valid for three days',
    stringKey: 'PASS_MODAL_DATE_RANGE',
  },
  PASS_MODAL_DATE_RANGE_ALTERNATE_PLURAL: {
    description: 'Date Range Alternate Plural',
    primaryValue: 'Pass only active for {{number}} days because of the date pass type selected',
    stringKey: 'PASS_MODAL_DATE_RANGE_ALTERNATE_PLURAL',
  },
  PASS_MODAL_DATE_RANGE_ALTERNATE_SINGLE: {
    description: 'Date Range Alternate Single',
    primaryValue: 'Pass only active for {{number}} day because of date pass type selected',
    stringKey: 'PASS_MODAL_DATE_RANGE_ALTERNATE_SINGLE',
  },
  PASS_MODAL_DATE_RANGE_HEADING: {
    description: 'Date Range Heading',
    primaryValue: 'Date Range',
    stringKey: 'PASS_MODAL_DATE_RANGE_HEADING',
  },
  PASS_MODAL_DATE_RANGE_MULTIPLE: {
    description: 'Date Range Multiple',
    primaryValue: 'Most pass types are valid for {{number}} days',
    stringKey: 'PASS_MODAL_DATE_RANGE_MULTIPLE',
  },
  PASS_MODAL_DATE_RANGE_SINGLE: {
    description: 'Date Range Single',
    primaryValue: 'Most pass types are valid for {{number}} day',
    stringKey: 'PASS_MODAL_DATE_RANGE_SINGLE',
  },
  PASS_MODAL_EMAIL_CONFIRMATION: {
    description: 'Email Confirmation',
    primaryValue: 'A confirmation will be sent directly to your guest',
    stringKey: 'PASS_MODAL_EMAIL_CONFIRMATION',
  },
  PASS_MODAL_EMAIL_ERROR: {
    description: 'Email Error',
    primaryValue: 'Please enter a valid email address',
    stringKey: 'PASS_MODAL_EMAIL_ERROR',
  },
  PASS_MODAL_GUEST_INFO_HEADING: {
    description: 'Guest Info Heading',
    primaryValue: 'Guest Info',
    stringKey: 'PASS_MODAL_GUEST_INFO_HEADING',
  },
  PASS_MODAL_GUEST_INFO_HEADING_SELF_INVITE: {
    description: 'Guest Info Heading for Self Invite',
    primaryValue: 'My Info',
    stringKey: 'PASS_MODAL_GUEST_INFO_HEADING_SELF_INVITE',
  },
  PASS_MODAL_GUEST_TAB: {
    description: 'Guest Tab',
    primaryValue: 'Guest',
    stringKey: 'PASS_MODAL_GUEST_TAB',
  },
  PASS_MODAL_MEMBERSHIP: {
    description: 'Membership Requirement',
    primaryValue: 'Guest must be a registered Nike⁠+ member:',
    stringKey: 'PASS_MODAL_MEMBERSHIP',
  },
  PASS_MODAL_MEMBERSHIP_LEARN_MORE: {
    description: 'Membership Learn More',
    primaryValue: 'Learn More',
    stringKey: 'PASS_MODAL_MEMBERSHIP_LEARN_MORE',
  },
  PASS_MODAL_NO_GUEST_PASSES: {
    description: 'No Guest Passes Available',
    primaryValue: 'No guest passes available',
    stringKey: 'PASS_MODAL_NO_GUEST_PASSES',
  },
  PASS_MODAL_NO_GUEST_PASSES_OVER_ALLOCATE: {
    description: 'No Guest Passes Over Allocate',
    primaryValue: 'No guest passes available: Adding a pass will over-allocate annual pass',
    stringKey: 'PASS_MODAL_NO_GUEST_PASSES_OVER_ALLOCATE',
  },
  PASS_MODAL_NO_VIP_PASSES: {
    description: 'No VIP Passes Available',
    primaryValue: 'No VIP passes available',
    stringKey: 'PASS_MODAL_NO_VIP_PASSES',
  },
  PASS_MODAL_NO_VIP_PASSES_OVERALLOCATE: {
    description: 'No VIP Passes Over Allocate',
    primaryValue: 'No VIP passes available: Adding a VIP will over-allocate',
    stringKey: 'PASS_MODAL_NO_VIP_PASSES_OVERALLOCATE',
  },
  PASS_MODAL_REGISTER: {
    description: 'Register',
    primaryValue: 'Register',
    stringKey: 'PASS_MODAL_REGISTER',
  },
  PASS_MODAL_REGISTER_CHECK_IN: {
    description: 'Register and Check In',
    primaryValue: 'Register and Check In',
    stringKey: 'PASS_MODAL_REGISTER_CHECK_IN',
  },
  PASS_MODAL_STORE_HEADING: {
    description: 'Store Heading',
    primaryValue: 'Store',
    stringKey: 'PASS_MODAL_STORE_HEADING',
  },
  DDL_STORE_SELECT: {
    description: 'Select Store',
    primaryValue: 'Select Store',
    stringKey: 'DDL_STORE_SELECT',
  },
  PASS_MODAL_TITLE: {
    description: 'Pass Modal Title',
    primaryValue: 'Request A Pass',
    stringKey: 'PASS_MODAL_TITLE',
  },
  PASS_MODAL_UNLIMITED: {
    description: 'Unlimited Passes',
    primaryValue: 'Unlimited',
    stringKey: 'PASS_MODAL_UNLIMITED',
  },
  PASS_MODAL_UPDATE: {
    description: 'Update',
    primaryValue: 'Update',
    stringKey: 'PASS_MODAL_UPDATE',
  },
  PASS_MODAL_VENDOR_HEADING: {
    description: 'Vendor Heading',
    primaryValue: 'Vendor',
    stringKey: 'PASS_MODAL_VENDOR_HEADING',
  },
  PASS_MODAL_VENDOR_INFO_HEADING: {
    description: 'Vendor Info Heading',
    primaryValue: 'Vendor Info',
    stringKey: 'PASS_MODAL_VENDOR_INFO_HEADING',
  },
  PASS_MODAL_VENDOR_TAB: {
    description: 'Vendor Tab',
    primaryValue: 'Vendor',
    stringKey: 'PASS_MODAL_VENDOR_TAB',
  },
  PASS_MODAL_VIP_INFO_HEADING: {
    description: 'VIP Info Heading',
    primaryValue: 'VIP Info',
    stringKey: 'PASS_MODAL_VIP_INFO_HEADING',
  },
  PASS_MODAL_VIP_TITLE: {
    description: 'VIP Title',
    primaryValue: 'Add VIP',
    stringKey: 'PASS_MODAL_VIP_TITLE',
  },
  PASS_MODAL_WE_CHAT_ERROR: {
    description: 'WeChat Error',
    primaryValue: 'One of the following required: WeChat ID or Email',
    stringKey: 'PASS_MODAL_WE_CHAT_ERROR',
  },
  CANCEL_PASS_MODAL_CANCEL_PASS: {
    description: 'Cancel Pass',
    primaryValue: 'Cancel Pass',
    stringKey: 'CANCEL_PASS_MODAL_CANCEL_PASS',
  },
  CANCEL_PASS_MODAL_KEEP_PASS: {
    description: 'Keep Pass',
    primaryValue: 'Keep Pass',
    stringKey: 'CANCEL_PASS_MODAL_KEEP_PASS',
  },
  CANCEL_PASS_MODAL_NOTIFY: {
    description: 'Notify Visitor',
    primaryValue: 'Be sure to inform your visitor',
    stringKey: 'CANCEL_PASS_MODAL_NOTIFY',
  },
  CANCEL_PASS_MODAL_TITLE: {
    description: 'Cancel Pass Modal Title',
    primaryValue: 'Cancel this pass',
    stringKey: 'CANCEL_PASS_MODAL_TITLE',
  },
  EDIT_PASS_MODAL_TITLE: {
    description: 'Edit Pass Modal Title',
    primaryValue: 'Edit {{type}} Pass',
    stringKey: 'EDIT_PASS_MODAL_TITLE',
  },
  PASS_MODAL_VIP_TAB: {
    description: 'VIP Tab',
    primaryValue: 'VIP',
    stringKey: 'PASS_MODAL_VIP_TAB',
  },
  BULK_UPLOAD_ACTION_TEXT: {
    description: 'Bulk Upload Action Text',
    primaryValue: 'Bulk Upload',
    stringKey: 'BULK_UPLOAD_ACTION_TEXT',
  },
};

export default translations;
